import { service } from '@/utils/request'

export default {
    getDataList: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/pageList',
            method: 'get',
            params: params
        })
    },
    switch: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/online',
            method: 'post',
            params
        })
    },
    toTop: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/top',
            method: 'post',
            params
        })
    },
    remove: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/delete',
            method: 'post',
            params
        })
    },
    getDetail: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/detail',
            method: 'get',
            params: params
        })
    },
    relation: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/relation',
            method: 'post',
            params: params
        })
    },
    changeRank: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/changeRank',
            method: 'post',
            params
        })
    },
    save: (data) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/save',
            method: 'post',
            data
        })
    },
    deleteRelation: (params) => {
        return service({
            url: '/cloud/course/v1/admin/courseHotList/deleteRelation',
            method: 'post',
            params
        })
    },
    getDisciplineList: (params) => {
        return service({
            url: '/cloud/course/v1/discipline/list',
            method: 'post',
            params
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/courseRank.js